import "./style.less";

export default function cookieCompliance(
    ModalService,
    cookieModel,
    localStorageService,
    cookieFactory
) {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),
        controller: function ($scope, $rootScope, $timeout) {
            $scope.showCookieModal = function () {
                // FIXES : http://stackoverflow.com/questions/19305821/multiple-modals-overlay
                // Just provide a template url, a controller and call 'showModal'.

                ModalService.showModal({
                    template: require("./modal/template.html"),
                    controller: "cookieModalController",
                    inputs: {
                        cookieModel: cookieModel,
                        // lane: lane,
                    },
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.

                    /**
                     * Cookies - Force user to decide (prevent backdrop close)
                     */
                    let modalOptions = {}; // default

                    let cookies =
                        localStorageService.cookie.get("cookieCompliance");

                    if (!cookies) {
                        modalOptions = {
                            backdrop: "static",
                            keyboard: false,
                        };
                    }

                    modal.element.modal(modalOptions);

                    modal.close
                        .then(function (cookieCategories) {
                            localStorageService.cookie.set(
                                "cookieCompliance",
                                cookieFactory.filterGrantedCookieCategories(
                                    cookieCategories
                                ),
                                365
                            );

                            $rootScope.$broadcast("cookie-compliance-updated");

                            cookieFactory.setAllowedCookies();

                            //REMOVE Cookies which are no longer allowed - possibly reload
                            cookieFactory.removeDisallowCookies();
                        })
                        .catch(function (error) {
                            // error contains a detailed error message.
                            console.log(error);
                        });
                });
            };

            $timeout(function () {
                let allowedCookieCategories =
                    localStorageService.cookie.get("cookieCompliance");

                if (!allowedCookieCategories) {
                    $timeout(function () {
                        // wait for page to load IE EDGE + firefox issue
                        $scope.showCookieModal();
                    }, 500);
                }
            });
        },
    };
}
